import { BehaviorSubject } from 'rxjs';

class AuthManager {
    private isAuthenticatedSubject = new BehaviorSubject<boolean>(
        Boolean(localStorage.getItem('tokens')),
    );

    // Observable to subscribe to authentication state changes
    public isAuthenticated$ = this.isAuthenticatedSubject.asObservable();

    // Update authentication state
    public setAuthenticated(isAuthenticated: boolean) {
        this.isAuthenticatedSubject.next(isAuthenticated);
    }

    // Sync with localStorage changes
    public syncWithLocalStorage() {
        const tokensExist = Boolean(localStorage.getItem('tokens'));
        this.setAuthenticated(tokensExist);
    }
}

// Export a singleton instance
export const authManager = new AuthManager();